var React = require('react');

function Game (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35 10H5C3.16667 10 1.66667 11.5 1.66667 13.3333V26.6667C1.66667 28.5 3.16667 30 5 30H35C36.8333 30 38.3333 28.5 38.3333 26.6667V13.3333C38.3333 11.5 36.8333 10 35 10ZM35 26.6667H5V13.3333H35V26.6667ZM10 25H13.3333V21.6667H16.6667V18.3333H13.3333V15H10V18.3333H6.66667V21.6667H10V25ZM24.1667 25C25.5474 25 26.6667 23.8807 26.6667 22.5C26.6667 21.1193 25.5474 20 24.1667 20C22.786 20 21.6667 21.1193 21.6667 22.5C21.6667 23.8807 22.786 25 24.1667 25ZM33.3333 17.5C33.3333 18.8807 32.2141 20 30.8333 20C29.4526 20 28.3333 18.8807 28.3333 17.5C28.3333 16.1193 29.4526 15 30.8333 15C32.2141 15 33.3333 16.1193 33.3333 17.5Z"}));
}

Game.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Game;

Game.default = Game;
